import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InlineInputControlComponent } from '../../components/form/inline-input-control/inline-input-control.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, Validators } from '@angular/forms';
import { UploadImagesComponent } from '../../components/upload-images/upload-images.component';
import { UploadedImagesListComponent } from '../../components/upload-images/uploaded-images-list/uploaded-images-list.component';
import { OrderStatusBlockComponent } from '../../components/order-status-block/order-status-block.component';
import { NotAvailableOverlayComponent } from '../../components/not-available-overlay/not-available-overlay.component';

@Component({
  selector: 'app-history-and-chat-dialog',
  standalone: true,
  imports: [ButtonModule, RippleModule, InlineInputControlComponent, UploadImagesComponent, 
    UploadedImagesListComponent, OrderStatusBlockComponent, NotAvailableOverlayComponent],
  templateUrl: './history-and-chat-dialog.component.html',
  styleUrl: './history-and-chat-dialog.component.scss'
})
export class HistoryAndChatDialogComponent {

  public dialogData: any;

  public messageControl: FormControl = new FormControl('');
  constructor(private dialogRef: DynamicDialogRef, private config: DynamicDialogConfig){
    this.dialogData = this.config.data;
  }

  public closeDialog(){
    this.dialogRef.close()
  }

}
